import { useCallback } from 'react';
import { Tooltip, Typography } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { ApiService, AutoUpdatedFirmReportZipModel } from 'api';

const AutoUpdatedFirmZip = ({
  autoUpdatedZipStatus,
}: {
  autoUpdatedZipStatus: AutoUpdatedFirmReportZipModel | null;
}) => {
  const downloadZip = useCallback(async () => {
    if (autoUpdatedZipStatus?.status_label === AutoUpdatedFirmReportZipModel.status_label.COMPLETED) {
      try {
        const response = await ApiService.apiExcelExportsFullCompanyReportsAllReportsSignedUrlRead(
          autoUpdatedZipStatus.firm.toString(),
          autoUpdatedZipStatus.report_date!
        );
        globalThis.location.href = response.signed_url!;
      } catch (e) {
        enqueueSnackbar('Error downloading auto-updated firm zip.', { variant: 'error' });
      }
    }
  }, [autoUpdatedZipStatus]);

  if (!autoUpdatedZipStatus) {
    return (
      <Typography variant="body2" color="error" sx={{ marginLeft: '25px' }}>
        Auto-updated firm zip status not available. Save some changes in at least one portfolio valuation.
      </Typography>
    );
  }

  if (autoUpdatedZipStatus.status_label === AutoUpdatedFirmReportZipModel.status_label.IN_PROGRESS) {
    return (
      <Typography variant="body2" color="warning" sx={{ marginLeft: '25px' }}>
        Auto-updated firm zip is still in progress...
      </Typography>
    );
  }

  const tooltipMessage = `Last updated: ${new Date(
    autoUpdatedZipStatus.last_zip_file_update as string
  ).toLocaleString()}. Contains all valid reports for this measurement date.`;

  return (
    <Tooltip title={tooltipMessage} placement="right-start">
      <Typography
        variant="body2"
        color="success"
        onClick={downloadZip}
        sx={{ marginLeft: '25px', cursor: 'pointer', fontWeight: 'bold' }}
        component="a">
        Download Auto-Updated Firm Zip.
      </Typography>
    </Tooltip>
  );
};

export default AutoUpdatedFirmZip;
